export const COUNTRIES = {
      country1: {name:'England', icon:'gb-eng'}, 
      country2: {name:'France', icon:'fr'},
      country3: {name:'Germany', icon:'de'}, 
      country4: {name:'Italy', icon:'it'},
      country5: {name:'Spain', icon:'es'}
}